/* eslint padding-line-between-statements: 0 */
// BASEPALET = BOOTSTRAP-VUE

require('./bootstrap.js')
window.Vue = require('vue')

/**
 * Import the tailwind vue UI
 * */
require('./tailwind-vue.js')

// Create an Event Bus...
export const EventBus = new Vue()

import Auth from '../auth.js'
window.auth = new Auth()

// VUE-X STORE
import store from '../store/index.js'

// REQUEST router config and invest NProgress...
import router from '../router/index.js'

// Matomo
import VueMatomo from 'vue-matomo'

import VueFileAgent from 'vue-file-agent'
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'
Vue.use(VueFileAgent)

import VueVirtualScroller from 'vue-virtual-scroller'
Vue.use(VueVirtualScroller)
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import VueFormulateAutocomplete from '../../shared/components/VueFormulateAutocomplete.vue'
import VueFormulateTagsLabelSlot from '../../careerwise/shared/connections/VueFormulateTagsLabelSlot.vue'
import VueFormulateTagsSelect from '../../careerwise/shared/connections/VueFormulateTagsSelect.vue'
import VueFormulateToggle from '../../careerwise/shared/connections/VueFormulateToggle.vue'
Vue.component('VueFormulateAutocomplete', VueFormulateAutocomplete)
Vue.component('VueFormulateTagsLabelSlot', VueFormulateTagsLabelSlot)
Vue.component('VueFormulateTagsSelect', VueFormulateTagsSelect)
Vue.component('VueFormulateToggle', VueFormulateToggle)

import VueFormulate from '@braid/vue-formulate'
// @TODO keep config contained elsewhere!
const VueFormulateConfig = {
  library: {
    autocomplete: {
      classification: 'text',
      component: 'VueFormulateAutocomplete',
    },
    tags: {
      classification: 'tags',
      component: 'VueFormulateTagsSelect',
      slotComponents: {
        label: 'VueFormulateTagsLabelSlot',
      },
      slotProps: {
        component: ['isCollapsed', 'isFilter', 'displayOnly', 'connection'],
        label: ['count', 'isCollapsed'],
      },
    },
    toggle: {
      classification: 'box',
      component: 'VueFormulateToggle',
    },
  },
  classes: {
    outer(context) {
      switch (context.classification) {
        case 'tags':
          return 'border border-truegray-300 rounded-md p-4'
        default: {
          return 'formulate-input'
        }
      }
    },
    wrapper(context) {
      switch (context.classification) {
        case 'box':
          return 'formulate-input-wrapper flex justify-start items-center gap-2'
        case 'file':
          return 'formulate-input-wrapper flex flex-col justify-center items-center w-full gap-4 w-full h-full'
        case 'tags':
          return 'formulate-input-wrapper'
        default:
          return 'formulate-input-wrapper'
      }
    },
    label(context) {
      switch (context.classification) {
        case 'box':
          return 'formulate-input-label font-medium text-sm cursor-pointer'
        default:
          return 'formulate-input-label font-medium text-sm'
      }
    },
    element(context) {
      switch (context.classification) {
        case 'box':
          return 'formulate-input-element flex-shrink-0 flex'
        case 'file':
          return 'formulate-input-element bg-truegray-500 rounded-full h-52 w-52'
        default:
          return 'formulate-input-element'
      }
    },
    input(context) {
      switch (context.classification) {
        case 'button':
          return 'btn btn-black'
        case 'file':
          return 'appearance-none opacity-0 rounded-full cursor-pointer w-full h-full'
        case 'box':
          return 'h-5 w-5 cursor-pointer'
        case 'textarea':
          return 'flex justify-center items-center sm:text-sm text-bluegray-700 focus:text-black active:text-black focus:outline-none active:outline-none transition-all duration-100 ease-in-out border border-bluegray-300 focus:border-black active:border-black rounded bg-white p-4 mt-1 w-full'
        default:
          return 'flex justify-center items-center sm:text-sm text-bluegray-700 focus:text-black active:text-black focus:outline-none active:outline-none transition-all duration-100 ease-in-out border border-bluegray-300 focus:border-black active:border-black rounded bg-white px-4 h-12 w-full'
      }
    },
    help(context) {
      switch (context.classification) {
        case 'file':
          return 'formulate-input-help text-xs text-gray-600 italic text-center mt-1'
        default:
          return 'formulate-input-help text-xs text-gray-600 mb-2'
      }
    },
    error(context) {
      const baseClasses = 'text-xs text-red-700 mt-2 mb-0'
      switch (context.classification) {
        case 'file':
          return `formulate-input-error ${baseClasses} text-center`
        case 'box':
        case 'tags':
          return `formulate-input-error ${baseClasses} mt-4`
        default:
          return `formulate-input-error ${baseClasses}`
      }
    },
  },
  rules: {
    // 1000000 B = 1 MB
    maxImageSize: ({ value }) =>
      !value || value?.files?.[0]?.file?.size <= 1000000,
  },
}
Vue.use(VueFormulate, VueFormulateConfig)

router.beforeEach(async (to, from, next) => {
  window.Path = from.path

  const currentClient = store.getters['shared/getClient']

  // client may change across routes, i.e., logging into the Contributor dashboard
  // (client1contributor) from the central (client1) context - so we need
  // to check and update it on every route change
  let client = document.getElementsByTagName('body')[0].dataset.client
    ? document.getElementsByTagName('body')[0].dataset.client
    : 0

  if (client === 'client1' && to.path?.includes('/cloud/')) {
    client = 'client1contributor'
  }

  if (currentClient !== client) {
    await store.dispatch('shared/dispatchSetClient', client)

    if (auth.isAuthenticated()) {
      await auth.updateUser(to)
    }
  }

  /** Do not allow access to these routes if the user is not an administrator...  */
  if (to.matched.some((record) => record.meta.middlewareAuthAdmin)) {
    let admin = auth.isAdmin()
    let isAuthedAdmin = /true/i.test(admin) //returns true
    if (isAuthedAdmin !== true) {
      next({ path: '/' })
      return
    }
  }

  if (
    store.getters['shared/isContributorAdminConnectionsOnly'] &&
    !to.meta.isConnectionsOnlyAdminRoute
  ) {
    // If the user is a self-managed connection, they only have
    // access to connections-only routes - redirect them there
    const routeTo = router.options.routes.find(
      (route) => route.meta?.isConnectionsOnlyAdminRoute,
    )

    if (routeTo && routeTo.name !== to.name) {
      router.push({ name: routeTo.name })
    } else {
      next({ path: '/' })
    }

    return
  }

  // Dispatch any actions this route needs before mounting
  // @TODO Implement global/Vuex isLoading state for all components.
  // if (to.meta?.actions) {
  //   await store.dispatch('shared/dispatchUpdateIsLoading', true)
  // for (const action of to.meta.actions) {
  //   await store.dispatch(action)
  // }
  //   await store.dispatch('shared/dispatchUpdateIsLoading')
  // }

  // // Re-route to the homepage if this is an authed route and the admin has not logged in or does not have permission?
  // if (to.matched.some(record => record.meta.middlewareAdmin) && auth.isAdmin()) {
  //     next({path: '/manager',});
  //     return;
  // }

  // if (to.matched.some(record => record.meta.middlewareAuth)) {
  //     // Whenever we detect an aunauthorised session we boot them to the homepage
  //     if (!auth.isAuthenticated()) {
  //         next({path: '/',});
  //         return;
  //     }
  // }

  next()
})

router.beforeResolve((to, from, next) => {
  // NAVIGATION TEMPLATE GUARDS:

  // Let's write soem logic that will determine what client or service is allowed to access these router templates?
  let client = document.getElementsByTagName('body')[0].dataset.client
    ? document.getElementsByTagName('body')[0].dataset.client
    : false
  if (client) {
    // We only want CW Central access to this route
    if (
      client !== 'client1cloud' &&
      (to.name === 'OrganisationDirectory' ||
        to.name === 'OrganisationDirectory' ||
        to.name === 'ContributorDirectory')
    ) {
      document.location.href = '/'
    }
  }

  // NAVIGATION TEMPLATE GUARDS:

  if (to.name) {
    EventBus.$emit('pageTransition', to.name)
  }
  next()
})

// Apply NProgress as a global class for all templates to hook into. Fire it on route transition
// import NProgress from 'nprogress';
// window.NProgressThink = NProgress;

// Lottie animation global component
import Lottie from 'vue-lottie'
Vue.component('lottie', Lottie)

const site_id = document.getElementsByTagName('body')[0].dataset.matomo_tracking

// Matomo Analytics
Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://analyticsdj.com',
  siteId: site_id,

  // Changes the default .js and .php endpoint's filename
  // Default: 'matomo'
  trackerFileName: 'matomo',

  // Overrides the autogenerated tracker endpoint entirely
  // Default: undefined
  // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

  // Overrides the autogenerated tracker script path entirely
  // Default: undefined
  // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

  // Enables automatically registering pageviews on the router
  router: router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Run Matomo without cookies
  // Default: false
  disableCookies: false,

  // Require consent before creating matomo session cookie
  // Default: false
  requireCookieConsent: false,

  // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
  // Default: false
  enableHeartBeatTimer: false,

  // Set the heartbeat timer interval
  // Default: 15
  heartBeatTimerInterval: 15,

  // Whether or not to log debug information
  // Default: false
  debug: false,

  // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
  // Default: undefined
  userId: undefined,

  // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
  // Default: undefined, example '*.example.com'
  cookieDomain: undefined,

  // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
  // Default: undefined, example: '*.example.com'
  domains: undefined,

  // A list of pre-initialization actions that run before matomo is loaded
  // Default: []
  // Example: [
  //   ['API_method_name', parameter_list],
  //   ['setCustomVariable','1','VisitorType','Member'],
  //   ['appendToTrackingUrl', 'new_visit=1'],
  //   etc.
  // ]
  preInitActions: [],

  // A function to determine whether to track an interaction as a site search
  // instead of as a page view. If not a function, all interactions will be
  // tracked as page views. Receives the new route as an argument, and
  // returns either an object of keyword, category (optional) and resultsCount
  // (optional) to track as a site search, or a falsey value to track as a page
  // view.
  // Default: false, i.e. track all interactions as page views
  // Example: (to) => {
  //   if (to.query.q && to.name === 'search') {
  //     return { keyword: to.query.q, category: to.params.category }
  //   } else {
  //    return null
  //   }
  // }
  trackSiteSearch: false,

  // Set this to include crossorigin attribute on the matomo script import
  // Default: undefined, possible values : 'anonymous', 'use-credentials'
  crossOrigin: undefined,
})

// V-calendar
import VCalendar from 'v-calendar'
Vue.use(VCalendar, {
  componentPrefix: 'v',
})

// Vue EllipseProgress
import VueEllipseProgress from 'vue-ellipse-progress'
Vue.use(VueEllipseProgress)

// ******** BUNDLE THE APP *********
import Base from '../../shared/pages/Base.vue'
const app = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(Base),
})
